// FAZ-10.6 / K-37 — placeholder-ekle yardımcısı (K-22 borcu kapanır). Prop
// tasarımcısındaki dış prop anahtarlarını çip olarak listeler; bir çipe tıklayınca
// `{{key}}` panoya kopyalanır → editör blok metin/bağlantı alanına yapıştırır.
// (Puck alanları birbirinden bağımsız olduğundan "odaklı alana enjekte" yerine
// panoya-kopya deseni; her alanda çalışır.)

import { Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import type { PropFieldModel } from '../types';

interface PlaceholderChipsProps {
  props: PropFieldModel[];
}

export function PlaceholderChips({ props }: PlaceholderChipsProps) {
  const { t } = useTranslation('component-studio');
  const keys = Array.from(new Set(props.map((p) => p.key.trim()).filter((k) => k.length > 0)));

  const copy = (key: string) => {
    const token = `{{${key}}}`;
    void navigator.clipboard?.writeText(token);
    toast.success(t('toast.placeholderCopied', { value: token }));
  };

  return (
    <div data-testid="placeholder-chips">
      <Typography.Text style={{ fontSize: 12, color: 'var(--ds-text-secondary)' }}>
        {t('editor.placeholders.title')}
      </Typography.Text>
      <div style={{ marginTop: 6 }}>
        {keys.length === 0 ? (
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {t('editor.placeholders.empty')}
          </Typography.Text>
        ) : (
          <Space size={[4, 8]} wrap>
            {keys.map((key) => (
              <Tag
                key={key}
                style={{ cursor: 'pointer', margin: 0 }}
                onClick={() => copy(key)}
              >{`{{${key}}}`}</Tag>
            ))}
          </Space>
        )}
      </div>
      <Typography.Text type="secondary" style={{ fontSize: 11, display: 'block', marginTop: 6 }}>
        {t('editor.placeholders.hint')}
      </Typography.Text>
    </div>
  );
}
